// eslint-disable-next-line no-undef
const apiUrl = process.env.REACT_APP_API_URL || 'https://dev-server.acuityriskconsultants.com/api/v1'
export default apiUrl
